// NOP Thresholds (ConsolidatedExposure) — mirrors NopThresholdDto + the save input.
// thresholdType: 1 = Net Volume (NOP Threshold), 2 = Volume Matching.
export const NOP_THRESHOLD_TYPE = { netVolume: 1, volumeMatching: 2 } as const;

export interface NopThresholdDto {
  id: number;
  name: string;
  isActive: boolean;
  summary?: string | null;
  thresholdType: number;
  targetTypes: number[];
  symbols: string[];
  thresholdValue1?: number | null;
  thresholdValue2?: number | null;
  thresholdValue3?: number | null;
  applyToAllSymbols: boolean;
  hedgeStatuses: number[];
  sendEmailNotifications: boolean;
  recipientEmails?: string[] | null;
}

// Save payload (id null = create). Matches nopReadForm / vmReadForm.
export interface NopThresholdSaveDto {
  id: number | null;
  name: string;
  thresholdType: number;
  targetTypes: number[];
  symbols: string[];
  thresholdValue1?: number | null;
  thresholdValue2?: number | null;
  thresholdValue3?: number | null;
  applyToAllSymbols?: boolean;
  hedgeStatuses?: number[];
  isActive: boolean;
  sendEmailNotifications: boolean;
}
